import { Breadcrumbs, Link, styled, useTheme } from "@mui/material";
import { ChevronRight } from "lucide-react";
import { useContext } from "react";
import { useTranslation } from "react-i18next";
import type { Level } from "types";
import { UserNavigationContext } from "../../context/UserNavigationContext";
import { getNavigationTarget } from "../../utils/general";

type INavigationBreadcrumbs = {
    learningObjectTypology:  Level;
    previousPath: string;
}

const regex = /[^/]+$/;

export const NavigationBreadcrumbs = ({ learningObjectTypology, previousPath }: INavigationBreadcrumbs)=>{
  const { t } = useTranslation();
  const theme = useTheme();
  const { navigation } = useContext(UserNavigationContext);
  const { target } = getNavigationTarget(navigation);
  const currentPath = window.location.href.includes("per-te") ? "per-te" : "esplora";


  function typeActualObject(LOtype: Level) {
    if(LOtype !== "PATH" && LOtype !== "COURSE"){
      return t("activities");
    }
    if(LOtype === "PATH") return t("Percorso");
    if(LOtype === "COURSE") return t("Corso");  
  }

  function handleParent(LOtype: Level) {
    console.log("LOtype", LOtype);
    
    if(LOtype === "PATH"){
      // PERCORSO - iL percorso non ha genitori, quindi mostriamo Esplora o Per te in base alla posizione precedente dell'utente
      return t(currentPath === "per-te" ? t("for_you") : "explore");
    }
    
    // CORSO o ATTIVITA' - i corsi o le attivita' possono essere figli delle sezioni principale (esplora, per te, community, preferiti, agenda) o di un percorso, quindi mostriamo 
    console.log("previousPath", previousPath);
    
    const parentLOType = previousPath.match(regex)?.[0];
    if(parentLOType === "PATH"){
      return t("package"); // traduzione di "percorso"
    }

    return parentLOType ? t(parentLOType?.toLowerCase()) : "";
  }

  return (
    <BreadcrumbsBanner id="hero-banner-breadcrumbs" aria-label="breadcrumb" separator={ <ChevronRight color={ theme.customColors.textPrimary } size="0.875rem" /> }>

      <ParentCrumb underline="none" href={  previousPath ?? target } color={ theme.customColors.textPrimary } textTransform="capitalize">
        { handleParent(learningObjectTypology) }
      </ParentCrumb>
     
      <ActualtCrumb underline="none" color={ theme.customColors.textPrimary } textTransform="capitalize" fontWeight={ 600 } fontSize="0.75rem" >
        { typeActualObject(learningObjectTypology) }
      </ActualtCrumb>
    </BreadcrumbsBanner>
  );  
};


const ParentCrumb = styled(Link)(() =>({
  cursor: "pointer",
  fontWeight: 400,
  fontSize: "0.75rem"
}));
const ActualtCrumb = styled(Link)(() =>({
  cursor: "text",
  fontWeight: 600,
  fontSize: "0.75rem"
}));
const BreadcrumbsBanner = styled(Breadcrumbs)(() =>({
  position: "absolute",
  top: "2rem",
  left: "2.5rem",
  lineHeight: "1rem"
}));
